export const environment = {
  API_URL: import.meta.env.VITE_API_URL,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  SENTRY_TRACES_SAMPLE_RATE: Number.isFinite(
    parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE),
  )
    ? parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE)
    : 0.2,
  MSB: import.meta.env.VITE_MSB,
  MSB_LOGO: import.meta.env.VITE_MSB_LOGO,
  MSB_LOGO_LOADING: import.meta.env.VITE_MSB_LOGO_LOADING,
  MAIN_COLOR: import.meta.env.VITE_MAIN_COLOR,
  DESTRUCTIVE_COLOR: import.meta.env.VITE_DESTRUCTIVE_COLOR,
}
